import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step-nav step-nav--ticket" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "step-nav__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepViews, (view, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["step-nav__item", {
                 'is-active': index === _ctx.step,
                 'is-completed' : index < _ctx.step }]),
        onClick: ($event: any) => (_ctx.changeStep(index, view))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.ticket.configuration.' + view + '-view')), 1)
      ], 10, _hoisted_2))
    }), 256))
  ]))
}